function hexParaHSL(hex: string) {
  hex = hex.replace("#", "");
  if (hex.length === 3) {
    hex = hex.split("").map(c => c + c).join("");
  }

  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5
      ? d / (2 - max - min)
      : d / (max + min);

    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)); break;
      case g: h = ((b - r) / d + 2); break;
      case b: h = ((r - g) / d + 4); break;
    }
    
    h = h || 1;

    h /= 6;
  }

  return {
    h: Math.round(h * 360),
    s: Math.round(s * 100),
    l: Math.round(l * 100)
  };
}

/**
 * Luminância relativa (WCAG). É o mesmo critério do tema por portal no painel e
 * no app do cliente — e não a *lightness* do HSL, que trata amarelo e azul do
 * mesmo jeito: `#ffe600` tem lightness 50 e recebia texto branco, com contraste
 * de 1,07:1. Ilegível.
 */
function luminanciaRelativa(hex: string): number {
  const normalizado = hex.replace("#", "");
  const completo = normalizado.length === 3
    ? normalizado.split("").map(c => c + c).join("")
    : normalizado;

  const [r, g, b] = [0, 2, 4].map((inicio) => {
    const canal = parseInt(completo.slice(inicio, inicio + 2), 16) / 255;
    return canal <= 0.03928 ? canal / 12.92 : Math.pow((canal + 0.055) / 1.055, 2.4);
  });

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function retornaCorDaBadge(hexFundo: string) {
  if (!hexFundo) return "#000";

  // O tom escuro acompanha o matiz do fundo, para a badge não ficar com um
  // preto solto no meio de um cartão colorido.
  const { h, s } = hexParaHSL(hexFundo);

  return luminanciaRelativa(hexFundo) > 0.45 ? `hsl(${h}, ${s}%, 5%)` : "white";
}